import { participantListSchema } from '@koderek/shared';
import { Button, Center, Loader, Stack, Text, Title } from '@mantine/core';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { Link, useSearchParams } from 'react-router';
import { apiGet } from '../api/client';
import { ErrorAlert } from '../components/ErrorAlert';
import { safeReturnTo } from '../features/auth/session';
import { ParticipantsManager } from '../features/participants/ParticipantsManager';
import { t } from '../texts/pl';

/** US-401…US-404: osoby z konta opiekuna. */
export function FamilyPage() {
  const [params] = useSearchParams();
  const client = useQueryClient();
  const list = useQuery({ queryKey: ['participants'], queryFn: () => apiGet('/participants', participantListSchema) });
  const back = params.get('powrot');

  return (
    <Stack gap="md" maw={720}>
      <Title order={1}>{t.participants.title}</Title>
      <Text c="dimmed">{t.participants.intro}</Text>
      {list.isPending ? (
        <Center py="lg">
          <Loader aria-label="Ładowanie" />
        </Center>
      ) : null}
      {list.isError ? <ErrorAlert error={list.error} /> : null}
      {list.data ? (
        <ParticipantsManager
          participants={list.data.participants}
          basePath="/participants"
          canRemove
          guardianEditHref="/konto"
          onChange={(participants) => {
            client.setQueryData(['participants'], { participants });
            void client.invalidateQueries({ queryKey: ['registration'] });
          }}
        />
      ) : null}
      {back ? (
        <Button component={Link} to={safeReturnTo(back)} variant="default" w="fit-content">
          {t.agenda.back}
        </Button>
      ) : null}
    </Stack>
  );
}
